import React from "react";

export default function TonOfBenefits() {

    return (
        <section className="py-0">
            <div className="container">
                <div className="row align-items-center position-relative">
                    <div className="col-lg-6">
                        <div
                            className="outside-box-left-5 md-outside-box-left-0"
                            data-bottom-top="transform:scale(1.1, 1.1)"
                            data-top-bottom="transform:scale(1, 1)"
                        >
                            <img
                                src="../../images/tons-of-benefits.png"
                                alt="matrixbrains pvt ltd tons of benefits"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div
                        className="col-lg-5 offset-lg-1 z-index-9 md-mt-35px"
                        data-anime='{ "el": "childs", "translateX": [15, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'
                    >
                        <h2 className="h2 text-dark-gray fw-600 mb-40px md-mb-25px outside-box-left-15 md-outside-box-left-0 ls-minus-3px word-break-normal">
                            Ton of benefits
                        </h2>
                        {/*<p className="w-85 lg-w-100">*/}
                        {/*    We are excited for our work and how it positively impacts clients.*/}
                        {/*    With over 12 year of experience have been constantly providing*/}
                        {/*    excellent.*/}
                        {/*</p>*/}
                        <ul className="p-0 m-0 list-style-02">
                            <li className="text-dark-gray pb-5px">
                                <i className="bi bi-check-lg fs-18 me-10px" />
                                Daily Reporting & Code Push
                            </li>
                            <li className="text-dark-gray pb-5px">
                                <i className="bi bi-check-lg fs-18 me-10px" />
                                Version Control Implementation
                            </li>
                            <li className="text-dark-gray pb-5px">
                                <i className="bi bi-check-lg fs-18 me-10px" />
                                Direct Communication
                            </li>
                            <li className="text-dark-gray pb-5px">
                                <i className="bi bi-check-lg fs-18 me-10px" />
                                Project Management Tools
                            </li>
                            <li className="text-dark-gray pb-5px">
                                <i className="bi bi-check-lg fs-18 me-10px" />
                                SCRUM Based Execution
                            </li>
                        </ul>
                        <div className="pt-20px pb-20px ps-30px pe-30px bg-white border-radius-6px box-shadow-medium w-80 lg-w-100 mt-30px mb-15px icon-with-text-style-08">
                            <div className="feature-box feature-box-left-icon-middle d-inline-flex align-top">
                                <div className="feature-box-icon me-15px">
                                    <i className="bi bi-people icon-very-medium text-dark-gray" />
                                </div>
                                <div className="feature-box-content">
                                    <span className="fw-600 text-dark-gray d-block lh-26">
                                        100+ people trusting agency.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}